// Variante mascarada de um termo de busca que seja um documento completo.
//
// A base grava CPF/CNPJ com máscara (o backend formata ao salvar), então
// quem digita só os dígitos não encontra o cadastro. Mas há registros
// antigos fora do padrão (CPF só com dígitos, CNPJ no campo de CPF…),
// por isso a máscara NÃO substitui o termo digitado: ela serve de
// segunda tentativa quando a busca literal volta vazia.
//
// Conservador de propósito: só reconhece termo que seja EXATAMENTE
// 11 dígitos (CPF) ou 14 dígitos (CNPJ); qualquer outra coisa devolve
// null e a busca segue como sempre foi.
export function maskedDocumentVariant(term: string): string | null {
  const trimmed = term.trim();
  if (/^\d{11}$/.test(trimmed)) {
    return trimmed.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  }
  if (/^\d{14}$/.test(trimmed)) {
    return trimmed.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    );
  }
  return null;
}
